/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, IconButton, makeStyles, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { RvLoader } from '../../components/Loader';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MTooltip from '@material-ui/core/Tooltip';
import { ChartInfo } from '../../components/ChartInfo';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartActionPill } from '../ChartActionPill';
import { ChartLimitNote } from '../ChartLimitNote';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartEmptyState } from '../ChartEmptyState';
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        rootLoader: {
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
        },
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        formControl: {
            display: 'flex',
            flexFlow: 'row wrap',
            alignItems: 'center',
            justifyContent: 'center',
        },
        formLabel: {
            marginRight: '10px',
        },
        scrollUp: {
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        }
    }),
);



interface TaskResponseTimeByAssigneeChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
}

interface ChartState {
    averageTime : number,
    taskNotStartedCount: number,
    taskCount: number[]
    responseTime: number[]
    grouping: string[],
    format: string[]
}

export const TaskResponseTimeByAssigneeChart: React.FC<TaskResponseTimeByAssigneeChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollUpAndPrevRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollDownAndNextRef = React.useRef<any>();

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0
    })[1];

    useEffect(() => {
        window.addEventListener('keydown', onKeyDownHandler);

        return () => {
            window.removeEventListener('keydown', onKeyDownHandler);
        };
        // tslint:disable-next-line: align
    }, []);

    // tslint:disable-next-line:no-any
    const taskResponseTimeByAssigneeQuery = useQuery<TaskResponseTimeByGroupAssigneeQueryData, TaskResponseTimeByGroupAssigneeQueryParams>(TaskResponseTimeByGroupAssigneeQuery, {
        variables: {
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
            showAllRecords: props.showAllRecords
        },
        fetchPolicy: 'cache-and-network',
    });

    
    const [state, setState] = useState<ChartState>({
        averageTime: 0,
        taskNotStartedCount: 0,
        responseTime: [],
        taskCount: [],
        grouping: [],
        format: []
    });

    useEffect(() => {
        let averageTime : number = 0;
        let taskNotStartedCount: number = 0;
        let responseTime: number[] = [];
        let taskCount: number[] = [];
        let grouping: string[] = [];
        let format: string[] = [];

        if (
            taskResponseTimeByAssigneeQuery.data &&
            taskResponseTimeByAssigneeQuery.data.statistics &&
            taskResponseTimeByAssigneeQuery.data.statistics.tasks &&
            !taskResponseTimeByAssigneeQuery.loading &&
            !taskResponseTimeByAssigneeQuery.error
        ) {
            setState((prevState) => {
                averageTime = taskResponseTimeByAssigneeQuery.data?.statistics.tasks.taskResponseTimeByGroupAssignee.averageTime ?? 0;
                taskNotStartedCount = taskResponseTimeByAssigneeQuery.data?.statistics.tasks.taskResponseTimeByGroupAssignee.taskNotStartedCount ?? 0;

                responseTime = taskResponseTimeByAssigneeQuery.data?.statistics.tasks.taskResponseTimeByGroupAssignee.responseTimesByGroupAssignee.map((data: ResponseTimesByGroupAssignee) => data.responseTime) ?? [];
                taskCount = taskResponseTimeByAssigneeQuery.data?.statistics.tasks.taskResponseTimeByGroupAssignee.responseTimesByGroupAssignee.map((data: ResponseTimesByGroupAssignee) => data.taskCount) ?? [];
                grouping = taskResponseTimeByAssigneeQuery.data?.statistics.tasks.taskResponseTimeByGroupAssignee.responseTimesByGroupAssignee.map((data: ResponseTimesByGroupAssignee) => data.grouping) ?? [];
                format = taskResponseTimeByAssigneeQuery.data?.statistics.tasks.taskResponseTimeByGroupAssignee.responseTimesByGroupAssignee.map((data: ResponseTimesByGroupAssignee) => data.format) ?? [];

                return {
                    ...prevState,
                    averageTime,
                    taskNotStartedCount,
                    responseTime,
                    taskCount,
                    grouping,
                    format
                };
            });
        }

        // tslint:disable-next-line: align
    }, [taskResponseTimeByAssigneeQuery.loading, taskResponseTimeByAssigneeQuery.error, taskResponseTimeByAssigneeQuery.data]);

    // tslint:disable-next-line: no-any
    const onKeyDownHandler = (event: any) => {
        if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey) {
            event.preventDefault();
            if (event.stopImmediatePropagation) {
                event.stopImmediatePropagation();
            } else {
                event.stopPropagation();
            }
            return;
        }
    };

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart('isTaskResponseTimeByAssigneeChartOpen');
        }
    };

    const onScrollUpAndPrev = (type: 'up' | 'prev') => {
        if (chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min > 0) {
            const scrollRatio = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            const min = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            if (scrollRatio < chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min) {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= scrollRatio ? scrollRatio : 1;
            } else {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= min;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= min;
            }
            chartRef.current.options.scales[type === 'up' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll up
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll up
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }
        scrollDownAndNextRef.current.classList.remove('Mui-disabled');
    };

    const onScrollDownAndNext = (type: 'down' | 'next') => {

        const labels= state.format;

        if (chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max < labels.length) {
            const remainingBar = labels.length - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max;
            const scrollRatio = chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min;
            if (remainingBar <= scrollRatio) {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += remainingBar;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += remainingBar;
            } else {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += scrollRatio ? scrollRatio : 1;
            }
            chartRef.current.options.scales[type === 'down' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll down
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll down
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
        scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
    };

    const onScollBar = (type: 'up' | 'down' | 'prev' | 'next') => () => {
        if (type === 'up') {
            onScrollUpAndPrev('up');
        } else if (type === 'down') {
            onScrollDownAndNext('down');
        } else if (type === 'next') {
            onScrollDownAndNext('next');
        } else {
            onScrollUpAndPrev('prev');
        }
    };

    const onDisabledEnabledArrow = (barType: 'horizontal' | 'vertical') => {
        const labels = state.format;
        // up 
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].min > 0) {
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }

        // down
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].max < labels.length) {
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
    };

    const onPan = (context: { chart: Chart }) => {

        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };

    const onZoom = (context: { chart: Chart }) => {

        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    // tslint:disable-next-line: no-any
    const onContextMenu = (event: any) => {
        event.preventDefault();
        if (event.button !== 2) {
            return false;
        }
        return true;
    };

    // tslint:disable-next-line: no-any
    const onDownload = (name: string, extension: string = 'jpg') => (image: any) => {
        const a = document.createElement('a');
        a.href = image;
        a.download = createFileName(extension, name);
        a.click();
    };

    const onDownloadScreenshot = () => {
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload('Average Phone Call Response Time'));
            // tslint:disable-next-line: align
        }, 500);
    };

    const onMaximize = () => {
        if (props.onMaximize) {
            props.onMaximize();
        }
    };

    const chartControllerComponent = () => {
        return (
            <>
                <IconButtonWrapper aria-label="close">
                    <ChartInfo 
                        description={props.description}
                        fontSize={props.showAllRecords ? 'large' : 'medium'}
                        className={`${classes.helpIcon} rv-chart-help`}
                    />
                    {props.showAllRecords && (
                        <IconButton size="medium" onClick={onDownloadScreenshot}>
                            <GetAppOutlinedIcon color="primary" fontSize="large" />
                        </IconButton>
                    )}
                    {!props.showAllRecords && props.onMaximize && (
                        <MTooltip title="Expand chart">
                            <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                                <AspectRatioIcon />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon className={classes.closeIcon} fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };
    
    if (taskResponseTimeByAssigneeQuery.loading || taskResponseTimeByAssigneeQuery.loading) {
        return (
            <div className={classes.rootLoader}>
                {chartControllerComponent()}
                <RvLoader size="small" />
            </div>
        );
    }

    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            searchCriterias.push(
                {
                    property: 'EntityType',
                    operator: 'eq',
                    comparison: '9'
                },
                {
                    property: 'InternalDescription',
                    operator: 'ne',
                    comparison: 'PhoneTask'
                },
                {
                    property: 'IsConfidential',
                    operator: 'eq',
                    comparison: '0',
                }
            );

            props.getSelectedItem(searchCriterias, true, `Drilldown from Average Task Response Time by Assignee`, DrillDownType.taskSummary, 'Phone Call' );
        }
    };

    const handleFooterClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            searchCriterias.push(
                {
                    property: 'EntityType',
                    operator: 'eq',
                    comparison: '9'
                },
                {
                    property: 'InternalDescription',
                    operator: 'ne',
                    comparison: 'PhoneTask'
                },
                {
                    property: 'IsConfidential',
                    operator: 'eq',
                    comparison: '0',
                },
                {
                    property: 'TaskStatus',
                    operator: 'eq',
                    comparison: 'TaskNotStarted',
                }
            );

            props.getSelectedItem(searchCriterias, true, `Drilldown from Average Task Response Time by Assignee`, DrillDownType.taskSummary, 'Phone Call' );
        }
    }
    
    if (taskResponseTimeByAssigneeQuery.loading) {
        return (
            <ChartSkeleton variant="bars" />
        );
    }

    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(state.responseTime) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
            {chartControllerComponent()}
            <div className={classes.titleContainer}>
                <ChartHeading icon={<AssignmentTurnedInOutlinedIcon />} title="Average Task Response Time" />
                <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                    <AnimatedNumber value={state.averageTime} format={(amount) => formatNumber(amount, 1)} />
                </div>
                <div className={classes.title}>Response Time in days by Assignee</div>
            </div>
            <div className={classes.barContainer} style={{ maxHeight: props.showAllRecords ? '100%' : '350px' }}>
                {props.showAllRecords && (
                    <>
                        <div className={`${classes.scrollUp} scroll`}>
                            <IconButton 
                                size="medium" 
                                onClick={onScollBar('up')}
                                ref={scrollUpAndPrevRef}
                            >
                                <KeyboardArrowUpIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                        <div className={`${classes.scrollDown} scroll`}>
                            <IconButton 
                                size="medium" 
                                onClick={onScollBar('down')}
                                ref={scrollDownAndNextRef}
                            >
                                <KeyboardArrowDownIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                    </>
                )}
                <Bar
                    ref={chartRef}
                    onContextMenu={onContextMenu}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            const _index = getElementAtEvent(chartRef.current, event)[0].index;
                            const item = state.grouping[_index];
                            const label = state.format[_index];
                            const searchCriterias = new Array<SearchCriteria>();

                            searchCriterias.push(
                                {
                                    property: 'AssignedTo',
                                    operator: 'eq',
                                    comparison: item,
                                },
                                {
                                    property: 'EntityType',
                                    operator: 'eq',
                                    comparison: '9',
                                },
                                {
                                    property: 'InternalDescription',
                                    operator: 'ne',
                                    comparison: 'PhoneTask',
                                },
                                {
                                    property: 'IsConfidential',
                                    operator: 'eq',
                                    comparison: '0',
                                }
                            );

                            props.getSelectedItem(
                                searchCriterias, 
                                true, 
                                `Drilldown from Average Task Response Time by Assignee - ${label}`, 
                                DrillDownType.taskSummary,
                                'All Columns' 
                            );
                        }
                    }}
                    data={{
                        labels: getLabels(state.format),
                        datasets: [
                            {
                                label: 'Average Response Time',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary, true),
                                data: state.responseTime,
                            },
                        ],
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'y' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: rvValueAxisStyle.grid,
                                stacked: true,
                                suggestedMax: getSuggestedMaxTick(state.responseTime),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit(state.responseTime),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        return `${formatNumber(tickValue)}`;
                                    },
                                },
                            },
                            y: {
                                grid: rvCategoryAxisStyle.grid,
                                stacked: true,
                                max: props.showAllRecords ? 29 : 9,
                                ticks: {
                                    ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false,
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: false,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: props.showAllRecords,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: props.showAllRecords,
                                    },
                                    onZoom: onZoom,
                                },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            formattedValue,
                                            dataset,
                                        } = context;

                                        var currentValue = convertStringNumberToNumber(formattedValue);

                                        return [`${dataset.label}: ${currentValue}`];
                                    },
                                    // tslint:disable-next-line: no-any no-shadowed-variable
                                    afterLabel: function (context: any) {

                                        const {
                                            dataIndex,
                                        } = context;

                                        const count = state.taskCount[dataIndex];

                                        return [
                                            `Number of Tasks: ${formatNumber(count)}`,
                                        ];
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(state.responseTime) && (
                    <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                )}
            </div>
            {!props.showAllRecords && (
                <ChartLimitNote>The top 10 are shown</ChartLimitNote>
            )}
            <ChartActionPill count={state.taskNotStartedCount} onClick={handleFooterClick}>
                tasks not yet started
            </ChartActionPill>
        </div>
    );
};

type TaskResponseTimeByGroupAssigneeQueryParams = {
    entityType?: number;
    entityGuid?: string;
    responsibility?: number;
    showAllRecords?: boolean;
};

type TaskResponseTimeByGroupAssigneeQueryData = {
    statistics: Statistics;
};

type Statistics = {
    tasks: Tasks;
};

type Tasks = {
    taskResponseTimeByGroupAssignee: TaskResponseTimeByGroupAssignee;
};

type TaskResponseTimeByGroupAssignee = {
    responseTimesByGroupAssignee: ResponseTimesByGroupAssignee[];
    averageTime:                  number;
    taskNotStartedCount:          number;
};

type ResponseTimesByGroupAssignee = {
    taskCount:    number;
    responseTime: number;
    format:       string;
    grouping:     string;
};

const TaskResponseTimeByGroupAssigneeQuery = gql`
    query TaskResponseTimeChartByAssigneeData(
        $entityType: Int
        $entityGuid: String
        $responsibility: Int
        $showAllRecords: Boolean
    ) {
        statistics {
            tasks {
                taskResponseTimeByGroupAssignee(
                    entityGuid: $entityGuid
                    entityType: $entityType
                    responsibility: $responsibility
                    showAllRecords: $showAllRecords
                ) {
                    responseTimesByGroupAssignee {
                        taskCount
                        responseTime
                        format
                        grouping
                    }
                    averageTime
                    taskNotStartedCount
                }
            }
        }
    }
`;
